import React, {  useContext } from "react";
import axios from "axios";
import { makeStyles, withStyles } from "@mui/styles";
import {
  CustomSelect,
  TextInput,
  FloatInput,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { zone } from "variables/patrimoine.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import {  getSite } from "services/ConfigServices";
import { NotificationManager } from 'react-notifications';


const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "10%",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "10%",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

function EditMaterialDialog(props) {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const {
    closeModal,
    refetch,
    materials,
    idSelected,
    prevMaterialList,
    clef,
    refmaterial,
    name,
    uncertainty,
    umaterial,
    thickness,
    thicknessprecision,
    comments,
    category,
    walltype,
    functionality,
    usualwall,
    thermicalconductivity,
    thermicalresistance,
    thermicalcapacity,
    volumicmass,
    carbonfootprint,
    greyenergy,
    vapordiffusion,
    loaded,
    handleClefChange,
    handleRefmaterialChange,
    handleNameChange,
    handleUncertaintyChange,
    handleUmaterialChange,
    handleThicknessChange,
    handleThicknessprecisionChange,
    handleCommentsChange,
    handleCategoryChange,
    handleWalltypeChange,
    handleFunctionalityChange,
    handleUsualwallChange,
    handleThermicalconductivityChange,
    handleThermicalresistanceChange,
    handleThermicalcapacityChange,
    handleVolumicmassChange,
    handleCarbonfootprintChange,
    handleGreyenergyChange,
    handleVapordiffusionChange,
  } = props;

  const handleSubmit = async (event) => {
    const indexToReplace = prevMaterialList.findIndex(
      (x) => x.uuid === idSelected
    );

    const editedEquipment = {
      clef,
      refmaterial,
      name,
      uncertainty,
      umaterial,
      thickness,
      thicknessprecision,
      comments,
      category,
      walltype,
      functionality,
      usualwall,
      thermicalconductivity,
      thermicalresistance,
      thermicalcapacity,
      volumicmass,
      carbonfootprint,
      greyenergy,
      vapordiffusion,
      'uuid': idSelected,
    };

    const materialList = prevMaterialList;
    materialList.splice(indexToReplace, 1, editedEquipment);

    axios
      .put(
        getSite(chartIdGroup, "structure.walls.materials"),
        materialList,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Matériau modifié");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
        closeModal();
        refetch();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <CustomSelect
                inputTitle={zone.structure.walls.materials.refmaterial}
                selectValue={refmaterial}
                handleSelectValueChange={handleRefmaterialChange}
                data={materials}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.key}
                textInput={clef}
                handleTextInputChange={handleClefChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.uncertainty}
                textInput={uncertainty}
                handleTextInputChange={handleUncertaintyChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.umaterial}
                floatInput={umaterial}
                handleFloatInputChange={handleUmaterialChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.thickness}
                floatInput={thickness}
                handleFloatInputChange={handleThicknessChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.thicknessprecision}
                floatInput={thicknessprecision}
                handleFloatInputChange={handleThicknessprecisionChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.comments}
                textInput={comments}
                handleTextInputChange={handleCommentsChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.category}
                textInput={category}
                handleTextInputChange={handleCategoryChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.walltype}
                textInput={walltype}
                handleTextInputChange={handleWalltypeChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.functionality}
                textInput={functionality}
                handleTextInputChange={handleFunctionalityChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.materials.usualwall}
                textInput={usualwall}
                handleTextInputChange={handleUsualwallChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.thermicalconductivity}
                floatInput={thermicalconductivity}
                handleFloatInputChange={handleThermicalconductivityChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.thermicalresistance}
                floatInput={thermicalresistance}
                handleFloatInputChange={handleThermicalresistanceChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.thermicalcapacity}
                floatInput={thermicalcapacity}
                handleFloatInputChange={handleThermicalcapacityChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.volumicmass}
                floatInput={volumicmass}
                handleFloatInputChange={handleVolumicmassChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.carbonfootprint}
                floatInput={carbonfootprint}
                handleFloatInputChange={handleCarbonfootprintChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.greyenergy}
                floatInput={greyenergy}
                handleFloatInputChange={handleGreyenergyChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.materials.vapordiffusion}
                floatInput={vapordiffusion}
                handleFloatInputChange={handleVapordiffusionChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "0px",
                marginBottom: "0px",
                marginTop: "15px",
                fontFamily: '"Source Sans Pro",sans-serif',
                width: "96%",
                marginLeft: "2%",
              }}
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </div>

  );
}

export default EditMaterialDialog;
